import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import PaymentGatewayFeesFields from './PaymentGatewayFeesFields'

export const PaymentGatewayFeesCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props} />} redirect="list" >
      <Grid container spacing={8}>
        <PaymentGatewayFeesFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default PaymentGatewayFeesCreate
